export const EnrollmentDropdowns = {
    timeIntervals: [
        {value:"AM", label:"AM"},
        {value:"PM", label:"PM"},
    ],
    hourIntervals: [
        {value:1, label:1},
        {value:2, label:2},
        {value:3, label:3},
        {value:4, label:4},
        {value:5, label:5},
        {value:6, label:6},
        {value:7, label:7},
        {value:8, label:8},
        {value:9, label:9},
        {value:10, label:10},
        {value:11, label:11},
        {value:12, label:12},
    ],
    repeatIntervals: [
        {value:"Day", label:"Day"},
        {value:"Min", label:"Min"},
        {value:"Hour", label:"Hour"},
        {value:"Week", label:"Week"},
        {value:"Month", label:"Month"},
    ],
    readings: [
        {value:"Automated", label:"Automated"},
        {value:"Manual", label:"Manual"},
        {value:"Both", label:"Both"}
    ],
    disabledVitals: [ // by modalityId
       14,  //fall
       17,   //activity type
       18,  //posture
       2    // pulse rate
    ]
      
};